import Storage from '@/lib/storage';
import { toErrorPage } from './common';
import store from '@/store';

const ls = new Storage('localStorage');

const whiteList = [
    // 不跟配置走的白名单
    `${ROUTER_PATH_PREFIX}/login`,
    `${ROUTER_PATH_PREFIX}/findpass`,
    `${ROUTER_PATH_PREFIX}/resetPassword`,
    `${ROUTER_PATH_PREFIX}/element/ui/demo`,
    `${ROUTER_PATH_PREFIX}/login/wxCheck`,
    `${ROUTER_PATH_PREFIX}/login/wxBind`,
    `${ROUTER_PATH_PREFIX}/login/wxBind`,
    `${ROUTER_PATH_PREFIX}/notice/detail`,
    `${ROUTER_PATH_PREFIX}/notice`,
    `${ROUTER_PATH_PREFIX}/information/detail`,
    `${ROUTER_PATH_PREFIX}/information`,
    `${ROUTER_PATH_PREFIX}/banner/detail`,
    `${ROUTER_PATH_PREFIX}/new-teacher/details`,
    `${ROUTER_PATH_PREFIX}/register`,
    `${ROUTER_PATH_PREFIX}/register/info`,
    `${ROUTER_PATH_PREFIX}/20th-anniversary`,
];

// 判断是否是首页或者登录页面
function checkIsLoginPage() {
    return whiteList.includes(window.location.pathname);
}

/**
 * 判断页面是否有权限
 * @param {*} keyArr
 * @returns
 */
function getIsHavePermission(keyArr) {
    if (!keyArr?.length) {
        return true;
    }
    let isHave = false;
    let pageMap = ls.getItem('pagePermission') || {};
    keyArr.forEach(element => {
        if (pageMap[element]) {
            isHave = true;
        }
    });
    return isHave;
}

/**
 * 检测框架层页，页面权限
 */
function checkPagePermission(curRoute = {}) {
    return new Promise((resolve, reject) => {
        let hasPermission = getIsHavePermission(curRoute.meta.checkPage);
        if (!hasPermission) {
            toErrorPage();
        }
        resolve(hasPermission);
    });
}

/**
 * 白名单
 */
function checkLoginPermission(curRoute) {
    return new Promise((resolve, reject) => {
        // 判断是否是白名单
        let isLoginPage = checkIsLoginPage();
        if (isLoginPage) {
            resolve(true);
            return;
        }
        // 判断是否是白名单 并且判断 是否配置了pc是否支持未登录状态访问首页
        let pageMap = ls.getItem('pagePermission') || {};
        let isConfig = pageMap?.pcAccessEnabled?.moduleRuleList?.[0]?.checked;
        let isConfigWhite = curRoute?.meta?.configWhite && isConfig;
        if (isConfigWhite) {
            // 如果是配置白名单并且已经配置了支持未登录状态访问首页
            resolve(true);
            return;
        }
        store.dispatch('checkIsLogout');
        resolve(false);
    });
}

export { checkPagePermission, checkLoginPermission };
